/**
 * Tiny notification store used everywhere instead of a toast library.
 * API kept compatible with what the app already calls: toast.success / error / info / message / warning,
 * plus toast(message) and toast.dismiss(id).
 */
let seq = 0;
let items = [];
const subs = new Set();
const emit = () => subs.forEach((f) => f(items));

function push(type, message, opts = {}) {
  const text = typeof message === "string" ? message : String(message ?? "");
  if (!text) return null;
  // the same message twice in a row just refreshes the existing card
  const same = items.find((t) => t.text === text && t.type === type);
  if (same) { same.at = Date.now(); same.bump = (same.bump || 0) + 1; items = [...items]; emit(); return same.id; }
  const id = ++seq;
  const duration = opts.duration ?? (type === "error" ? 6500 : 4500);
  items = [{ id, type, text, title: opts.title, description: opts.description, duration, at: Date.now() }, ...items].slice(0, 4);
  emit();
  return id;
}

export function toast(message, opts) { return push("info", message, opts); }
toast.success = (m, o) => push("success", m, o);
toast.error = (m, o) => push("error", m, o);
toast.info = (m, o) => push("info", m, o);
toast.message = (m, o) => push("info", m, o);
toast.warning = (m, o) => push("error", m, o);
toast.dismiss = (id) => { items = id == null ? [] : items.filter((t) => t.id !== id); emit(); };

export function subscribeToasts(fn) { subs.add(fn); fn(items); return () => subs.delete(fn); }
